import { QuoteReferralState, QuoteState } from "kw/api/zeus";
import { COLOR } from "baseui/badge";

export default function useQuoteStatus(quote: TQuote) {
  let color;
  switch (quote?.state) {
    case QuoteState.REFERRED:
      switch (quote?.referralState) {
        case QuoteReferralState.ACCEPTED:
          color = COLOR.positive;
          break;
        case QuoteReferralState.DECLINED:
          color = COLOR.negative;
          break;
        default:
          color = COLOR.warning;
          break;
      }
      break;
    case QuoteState.SUBMITTED:
      color = COLOR.positive;
      break;
    case QuoteState.QUOTED:
      color = COLOR.positive;
      break;
    case QuoteState.ACCEPTED:
      color = COLOR.positive;
      break;
    case QuoteState.KNOCKOUT:
      color = COLOR.negative;
      break;
    case QuoteState.EXPIRED:
      color = COLOR.negative;
      break;
    case QuoteState.DISCARDED:
      color = COLOR.negative;
      break;
    case QuoteState.DRAFT:
      color = COLOR.warning;
      break;
    default:
      color = COLOR.accent;
  }

  let caption = quote?.stateDisplay;
  if (quote?.referralState) {
    caption = `${caption} - ${quote?.referralStateDisplay}`;
  }
  return { caption, captionColor: color };
}
